<template>
   <span class="badge rounded-pill font-size-11"
         :class="{
            'badge-soft-info': status === 'loaded',
            'badge-soft-success': status === 'delivered',
            'badge-soft-warning': status === 'not loaded',
            'badge-soft-danger': status.includes('cancelled'),
            'badge-soft-secondary': status === 'open',
            'badge-soft-dark': status === 'returned',
            'badge-soft-primary': status !== '', /* Handle any other status */
          }">
  {{order_status}}</span>
</template>

<script>
export default {
name: "order-status-component",
  props:{
    order_status: {type: String}
  },
  computed: {
    status() {
      return this.order_status.trim().toLowerCase()
    }
  }
}
</script>

<style scoped>

</style>
